<template>
  <div class="wa-footer-wrapper">
    <img-v3 :src="formItem.icon_url" alt="" />
    <hr />
    <section>
      <a v-for="(item, idx) in urlList" :key="idx" :href="item.link">{{
        item.title
      }}</a>
    </section>
  </div>
</template>
<script>
export default {
  props: ["formItem"],
  mounted() {},
  computed: {
    urlList() {
      return this.formItem.list || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.wa-footer-wrapper {
  //   display: flex;
  //   align-items: center;
  width: 100%;
  // height: 2.12rem;
  margin-top: 0.48rem;
  padding: 0.32rem 0.4rem;
  box-sizing: border-box;
  background: #424242;
  > img {
    width: 1.28rem;
    height: 0.4rem;
  }
  > hr {
    width: 100%;
    height: 0.02rem;
    // margin: 0.32rem 0;
    opacity: 0.3;
    background: #ffffff;
    border: none;
  }
  > section {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    > a {
      width: 50%;
      font-size: 0.24rem;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 0.6;
    }
  }
}
</style>


